/**
 * Check if a tier has all prices set to 0, making it effectively a "VIP tier".
 * A tier is zero-price if:
 * - monthlyPrice is 0 or null/undefined
 * - vpsOverride is 0 or null/undefined
 * - All dynamicFee entries have fee === 0 (or no entries)
 *
 * Users on zero-price tiers:
 * - Don't need a payment method
 * - Keep active subscriptions
 * - Have billing periods advanced but no charges created
 *
 * @param {Object|null|undefined} tier - The subscription tier to check
 * @returns {boolean} - True if the tier has all zero prices
 */
import type { SubscriptionTier, SubscriptionTierRelation } from "@investhinks/api-client";

export function isZeroPriceTier(tier: SubscriptionTier | SubscriptionTierRelation | null | undefined) {
  if (!tier) return false;

  const hasMonthlyPrice = (tier.monthlyPrice ?? 0) > 0;
  const hasVpsCost = (tier.vpsOverride ?? 0) > 0;
  const dynamicFees = tier.dynamicFee ?? [];
  const hasNonZeroFee = dynamicFees.some((entry) => (entry.fee ?? 0) > 0);

  return !hasMonthlyPrice && !hasVpsCost && !hasNonZeroFee;
}

export default isZeroPriceTier;
